// Product Share Bar — inyecta el FAB dentro del contenedor principal (manual offsets)
(function () {
  'use strict';

  var DEFAULT_WRAPPER = '#product-media';

  // DOM ready helper
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn, { once: true });
  }

  // Copiar al portapapeles con fallback
  function copyToClipboard(text) {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        return navigator.clipboard.writeText(text);
      }
    } catch (_) {}
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', 'readonly');
    ta.style.position = 'fixed';
    ta.style.top = '-9999px';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); } catch (_) {}
    document.body.removeChild(ta);
    return Promise.resolve();
  }

  // Toast minimalista
  function showToast(msg) {
    if (document.getElementById('cib-copy-toast')) return;
    var t = document.createElement('div');
    t.id = 'cib-copy-toast';
    t.textContent = msg || 'Link copied ✔';
    document.body.appendChild(t);
    setTimeout(function () {
      if (t && t.parentNode) t.parentNode.removeChild(t);
    }, 1500);
  }

  // Inicializa una sección concreta
  function initSection(root) {
    try {
      if (!root || root.dataset.cibInit === '1') return;

      var holder = root.querySelector('.cib-fab-holder');
      var fabBtn = root.querySelector('.cib-fab');
      if (!holder || !fabBtn) return;

      var selector = (root.getAttribute('data-custom-selector') || DEFAULT_WRAPPER).trim();
      var wrapper = null;
      try { wrapper = document.querySelector(selector); } catch (_) {}
      if (!wrapper) return;

      // Asegurar posicionamiento absoluto viable
      var cs = window.getComputedStyle(wrapper);
      if (!cs.position || cs.position === 'static') {
        // Solo si es static forzamos relative (no tocamos sticky/fixed/absolute)
        wrapper.style.position = 'relative';
      }

      // Inyectar una sola vez dentro del wrapper
      if (holder.parentElement !== wrapper) {
        wrapper.appendChild(holder);
      }
      holder.classList.add('attached');

      // Datos para compartir
      var title = root.getAttribute('data-product-title') || document.title;
      var url   = root.getAttribute('data-product-url') || location.href;
      var msg   = root.getAttribute('data-share-message') || '';

      // Evitar listeners duplicados
      if (!fabBtn.dataset.cibBound) {
        fabBtn.addEventListener('click', function (e) {
          // Necesitamos preventDefault -> no usar passive:true
          e.preventDefault();
          // Evitar abrir zoom/lightbox del wrapper
          e.stopPropagation();

          try {
            if (navigator.share) {
              navigator.share({ title: title, text: msg, url: url }).catch(function () { /* noop */ });
            } else {
              copyToClipboard(title + ' — ' + msg + '\n\n' + url)
                .then(function () { showToast('Link copied ✔'); });
            }
          } catch (_) { /* noop */ }
        }, { capture: false, passive: false });

        fabBtn.dataset.cibBound = '1';
      }

      // Marcar como inicializado para no repetir trabajo en recargas del editor
      root.dataset.cibInit = '1';
    } catch (e) {
      console.warn('[ShareBar] init error', e);
    }
  }

  // Inicializa todas las instancias en la página
  function boot() {
    var nodes = document.querySelectorAll('.cib-fab-section');
    for (var i = 0; i < nodes.length; i++) {
      initSection(nodes[i]);
    }
  }

  // Arranque
  ready(boot);

  // Soporte para el editor de Shopify (cuando recarga/reordena secciones)
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:reorder', boot);

  // Limpieza defensiva cuando una sección se descarga del editor
  document.addEventListener('shopify:section:unload', function (e) {
    try {
      var secId = e && e.detail && e.detail.sectionId ? e.detail.sectionId : null;
      if (!secId) return;
      var container = document.getElementById('shopify-section-' + secId);
      if (!container) return;

      var btn = container.querySelector('.cib-fab');
      if (btn) {
        // Permite re-vincular si la sección vuelve a cargarse
        delete btn.dataset.cibBound;
      }
      // Permite re-inicializar si se vuelve a montar
      var root = container.querySelector('.cib-fab-section');
      if (root) delete root.dataset.cibInit;
    } catch (_) { /* noop */ }
  });
})();
